import React, { useEffect, useState } from 'react';
import { Checkbox } from 'antd';
import Icon from 'component/Icon';
import { letterPerson, Person } from 'type/contact';
import Avatar from 'component/Avatar';
import styles from './index.module.scss';
import ContactCard from 'component/ContactCard';
import { CONTACT_TITLE, CONTACT_TYPE } from 'constant/contact';
import noContactImg from 'asset/image/kts_ addressbook.png';
import { checked, checkedAll, disabled, disabledAll, getLetterPerson, indeterminate } from './util';
import { fridayAgent } from '@cvte/react-fridayagent3';
import tracker from 'lib/tracker';
import FRIDAYAGENT_EVENTS from 'constant/fridayAgentEvent';

interface IProps {
  className?: string;
  personList: any[];
  selectPerson?: Person[];
  disablePerson?: Person[];
  noPersonText?: string;
  noPersonIcon?: string;
  checkbox?: boolean; // 勾选
  checkAll?: boolean; // 全选
  deleteIcon?: boolean; // 删除
  checkedClick?: (person: Person) => void;
  unCheckedClick?: (person: Person) => void;
  deleteIconClick?: (person: Person) => void;
  onScroll?: (e: any) => void;
  type?: string;
  labelId?: number;
  contactCard?: boolean; // 点击弹出卡片
  setShowPopover?: (show: boolean) => void;
  showLetter?: boolean; // 显示字母
}

const PersonList: React.FunctionComponent<IProps> = ({
  className,
  personList = [],
  selectPerson = [] as Person[],
  disablePerson = [] as Person[],
  noPersonText,
  noPersonIcon,
  checkbox = false,
  checkAll = false,
  deleteIcon = false,
  checkedClick,
  unCheckedClick,
  deleteIconClick,
  onScroll,
  type,
  labelId,
  contactCard = false,
  setShowPopover,
  showLetter = false
}) => {
  const [showCard, setShowCard] = useState(false);
  const [contactInfo, setContactInfo] = useState<Person>();
  const [letterPerson, setLetterPerson] = useState<letterPerson[]>([]);

  useEffect(() => {
    showLetter && setLetterPerson(getLetterPerson(personList));
  }, [personList]);

  const onCheck = (person: Person, e: any) => {
    if (e.target.checked) {
      if (checkedClick) {
        checkedClick(person);
        // 埋点
        fridayAgent.pushData({
          ...FRIDAYAGENT_EVENTS.WEB_TEAMS_CLICK_ADD_MEMBER_CHECKED,
          data: { member_type_code: type, member_type_value: type && CONTACT_TITLE[type] }
        });
      }
    } else {
      unCheckedClick && unCheckedClick(person);
    }
  };

  const onCheckAll = (e: any) => {
    personList.forEach((person) => {
      if (!disablePerson?.filter((p) => p.staffId === person.staffId).length) {
        onCheck(person, e);
      }
    });
  };

  const showContactCard = (contact: Person) => {
    tracker?.reporteContactOperation('查看联系人');
    setContactInfo(contact);
    setShowCard(true);
    setShowPopover && setShowPopover(false);
  };

  const closeContactCard = () => {
    setShowCard(false);
  };

  const renderPersonList = (personList: Person[]) => {
    return (
      <>
        {personList.map((person) => {
          const { staffId, refId, avatar, jobTitle, company, department } = person;
          const id = staffId || refId;
          const remark = person.remark;
          const name = person.memberName || person.displayName || person.realName || person.realname || person.name;

          return (
            <div key={id} className={styles.personList}>
              <div className={styles.item}>
                {checkbox && id && (
                  <Checkbox
                    onChange={(e) => onCheck(person, e)}
                    className={styles.checkbox}
                    checked={checked(id, selectPerson, disablePerson)}
                    disabled={disabled(id, disablePerson)}
                  />
                )}
                <div className={styles.personInfo} onClick={() => showContactCard(person)}>
                  <Avatar src={avatar} />
                  <div className={styles.person}>
                    <span className={styles.name}>{type === CONTACT_TYPE.SEARCH && remark ? `${remark}（${name}）` : remark || name}</span>
                    <div className={styles.job}>
                      {type === CONTACT_TYPE.EXTERNAL || (type === CONTACT_TYPE.SELECTED && person.type === CONTACT_TYPE.EXTERNAL)
                        ? [company, jobTitle].filter((v) => !!v).join('/')
                        : [department, jobTitle].filter((v) => !!v).join('/')}
                    </div>
                  </div>
                </div>
              </div>
              {deleteIcon && <Icon type="iconlist_delete_ic" size={24} onClick={deleteIconClick?.bind(this, person)} />}
            </div>
          );
        })}
      </>
    );
  };

  const renderLetterPersonList = (letterPersons: letterPerson[]) => {
    return (
      <>
        {letterPersons.map((letterPerson) => (
          <div key={letterPerson.firstLetter}>
            <div className={styles.letter}>{letterPerson.firstLetter}</div>
            {renderPersonList(letterPerson.person)}
          </div>
        ))}
      </>
    );
  };

  return (
    <>
      <div className={className} onScroll={onScroll}>
        {!!personList.length && (
          <>
            {checkAll && (
              <div className={styles.checkAll}>
                <Checkbox
                  indeterminate={indeterminate(selectPerson, personList, disablePerson)}
                  onChange={onCheckAll}
                  checked={checkedAll(selectPerson, personList, disablePerson)}
                  disabled={disabledAll(personList, disablePerson)}
                >
                  <span className={styles.checkAllText}>全选</span>
                </Checkbox>
              </div>
            )}
            {showLetter ? renderLetterPersonList(letterPerson) : renderPersonList(personList)}
          </>
        )}
        {!personList.length && (
          // <div className={styles.noPerson}>{noPersonText}</div>
          <div className={styles.noContact}>
            {noPersonIcon && <img src={noContactImg} className={styles.noContactImg}></img>}
            <div className={styles.noContactText}>{noPersonText}</div>
          </div>
        )}
      </div>
      {contactInfo && (
        <ContactCard show={showCard && contactCard} handelClose={closeContactCard} contactInfo={contactInfo} type={type || ''} labelId={labelId || 0} />
      )}
    </>
  );
};

export default PersonList;
